import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectIsMobile } from 'redux/modules/device';
import { isAbsent, isEmpty, isPresent } from 'helpers/verify';
/**
 * The CardSelection component implements common logic for selecting from a collection of Cards
 * on desktop and mobile.
 *
 * CardSelection accepts two types of children: an array of render functions, or an object mapping
 * keys to render functions. The render function should return a node when invoked.
 * Invalid React elements will be filtered out. The renderFunction is invoked with:
 *
 *   renderFunction({
 *     handleSelection: function, // should be invoked when the card is selected (usually onClick).
 *     selected: boolean,         // true if the card was selected most recently, false otherwise.
 *   })
 *
 * On desktop, calling `handleSelection` invokes `onCardSelected` with the key of the card.
 *
 * On mobile, a CTA is rendered. `handleSelection` invocations persist the key of the card in state,
 * flagging the card as selected. When the CTA is clicked, `onCardSelected` is invoked with the key of
 * the flagged card.
 *
 *
 * Example:
 *
 * Object with render functions:
 *
 *   <CardSelection
 *     onCardSelected={key => console.log(key)} // "foo" or "bar"
 *   >
 *     {{
 *       foo: ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />,
 *       bar: ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />
 *     }}
 *   </CardSelection>
 *
 * Array with render functions:
 *
 *   <CardSelection
 *     onCardSelected={key => console.log(key)} // 0 or 1
 *   >
 *     {[
 *       ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />,
 *       ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />
 *     ]}
 *   </CardSelection>
 */

export var mapStateToProps = function mapStateToProps(state) {
  return {
    isMobile: selectIsMobile(state)
  };
};
export var CardSelectionUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(CardSelectionUnwrapped, _Component);

  function CardSelectionUnwrapped(props) {
    var _this;

    _classCallCheck(this, CardSelectionUnwrapped);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CardSelectionUnwrapped).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selected: _this.props.defaultSelected || null
    });

    _this.handleCtaClick = _this.handleCtaClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CardSelectionUnwrapped, [{
    key: "handleSelection",
    value: function handleSelection(key) {
      var _this$props = this.props,
          isMobile = _this$props.isMobile,
          onCardSelected = _this$props.onCardSelected;

      if (isMobile) {
        this.setState({
          selected: key
        });
      } else {
        onCardSelected(key);
      }
    }
  }, {
    key: "handleCtaClick",
    value: function handleCtaClick() {
      var selected = this.state.selected;

      if (isPresent(selected)) {
        this.props.onCardSelected(selected);
      }
    }
  }, {
    key: "renderCards",
    value: function renderCards() {
      var _this2 = this;

      var children = this.props.children;
      return Object.keys(children || []).map(function (key) {
        return children[key]({
          handleSelection: _this2.handleSelection.bind(_this2, key),
          selected: _this2.state.selected === key
        });
      }).filter(React.isValidElement);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isMobile = _this$props2.isMobile,
          mobileCtaCopy = _this$props2.mobileCtaCopy;
      var renderedCards = this.renderCards();
      return !isEmpty(renderedCards) && React.createElement("div", {
        className: "card-selection"
      }, React.createElement("div", {
        className: "card-selection__cards"
      }, renderedCards), isMobile && React.createElement("button", {
        className: "bt bt--primary bt--lg mv+",
        disabled: isAbsent(this.state.selected),
        onClick: this.handleCtaClick
      }, mobileCtaCopy));
    }
  }]);

  return CardSelectionUnwrapped;
}(Component);
CardSelectionUnwrapped.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.objectOf(PropTypes.func)]),
  defaultSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMobile: PropTypes.bool.isRequired,
  mobileCtaCopy: PropTypes.node.isRequired,
  onCardSelected: PropTypes.func.isRequired
};
export var CardSelection = connect(mapStateToProps)(CardSelectionUnwrapped);